export const SET_ACCOUNT_TOKEN = 'SET_ACCOUNT_TOKEN';
export const SESSION_STARTED = 'SESSION_STARTED';
export const SESSION_CONNECTED = 'SESSION_CONNECTED';
export const SESSION_AUTH_STARTED = 'SESSION_AUTH_STARTED';
export const SESSION_SET = 'SESSION_SET';
export const START_SESSION_ESTABLISHING = 'START_SESSION_ESTABLISHING';
export const START_LOADING = 'START_LOADING';
export const FINISH_LOADING = 'FINISH_LOADING';
export const START_VERIFY_SMS = 'START_VERIFY_SMS';
export const START_VERIFY_IMPRIVATA_ID_MANUAL = 'START_VERIFY_IMPRIVATA_ID_MANUAL';
export const START_ENROLL_SMS = 'START_ENROLL_SMS';
export const START_ENROLL_IMPRIVATA_ID = 'START_ENROLL_IMPRIVATA_ID';
export const START_ENROLL_VERIFY_SMS = 'START_ENROLL_VERIFY_SMS';
export const START_VERIFY_OTP = 'START_VERIFY_OTP';
export const START_CHANGE_PASSWORD = 'START_CHANGE_PASSWORD';
export const INPUT_SMS = 'INPUT_SMS';
export const INPUT_IMPRIVATA_ID_MANUAL = 'INPUT_IMPRIVATA_ID_MANUAL';
export const INPUT_SMS_ENROLL = 'INPUT_SMS_ENROLL';
export const INPUT_IMPRIVATA_ID_ENROLL = 'INPUT_IMPRIVATA_ID_ENROLL';
export const START_INPUT_ENROLL_SMS = 'START_INPUT_ENROLL_SMS';
export const START_INPUT_ENROLL_IMPRIVATA_ID = 'START_INPUT_ENROLL_IMPRIVATA_ID';
export const INPUT_OTP = 'INPUT_OTP';
export const INPUT_PASSWORD = 'INPUT_PASSWORD';
export const INPUT_PIN = 'INPUT_PIN';
export const INPUT_TEMPCODE = 'INPUT_TEMPCODE';
export const START_VERIFY_PASSWORD = 'START_VERIFY_PASSWORD';
export const START_VERIFY_PIN = 'START_VERIFY_PIN';
export const SMS_SUCCESS = 'SMS_SUCCESS';
export const IMPRIVATA_ID_MANUAL_SUCCESS = 'IMPRIVATA_ID_MANUAL_SUCCESS';
export const SMS_ENROLL_SUCCESS = 'SMS_ENROLL_SUCCESS';
export const SMS_ENROLL_VERIFY_SUCCESS = 'SMS_ENROLL_VERIFY_SUCCESS';
export const IMPRIVATA_ID_ENROLL_SUCCESS = 'IMPRIVATA_ID_ENROLL_SUCCESS';
export const OTP_SUCCESS = 'OTP_SUCCESS';
export const PASSWORD_SUCCESS = 'PASSWORD_SUCCESS';
export const PIN_SUCCESS = 'PIN_SUCCESS';
export const START_VERIFY_TEMPCODE = 'START_VERIFY_TEMPCODE';
export const TEMPCODE_SUCCESS = 'TEMPCODE_SUCCESS';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const SESSION_FAILED = 'SESSION_FAILED';
export const LOGIN_STARTED = 'LOGIN_STARTED';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const ENROLL_RETRY = 'ENROLL_RETRY';
export const CHANGE_PASSWORD_RETRY = 'CHANGE_PASSWORD_RETRY';
export const EDIT_PHONE_NUMBER = 'EDIT_PHONE_NUMBER';
export const BACK_TO_INTRODUCTION = 'BACK_TO_INTRODUCTION';
export const COMPLETE_AUTHENTICATION = 'COMPLETE_AUTHENTICATION';
export const SET_SERVER_STATE = 'SET_SERVER_STATE';
export const SET_TEMP_CODE_TO_MANUAL = 'SET_TEMP_CODE_TO_MANUAL';
export const SET_AVAILABLE_MODALITIES = 'SET_AVAILABLE_MODALITIES';
export const SET_AUTHENTICATED_MODALITIES = 'SET_AUTHENTICATED_MODALITIES';
export const REMOVE_FACE_MODALITY = 'REMOVE_FACE_MODALITY';
export const START_VERIFY_IMPRIVATA_ID = 'START_VERIFY_IMPRIVATA_ID';
export const IMPRIVATA_ID_PUSH_SUCCESS = 'IMPRIVATA_ID_PUSH_SUCCESS';
export const START_NUMBER_MATCHING_FOR_IMPRIVATA_ID = 'START_NUMBER_MATCHING_FOR_IMPRIVATA_ID';
export const IMPRIVATA_ID_NUMBER_MATCHING_SUCCESS = 'IMPRIVATA_ID_NUMBER_MATCHING_SUCCESS';
export const SET_PRIMARY_FACTOR_ENROLLED = 'SET_PRIMARY_FACTOR_ENROLLED';
export const LOGOUT = 'LOGOUT';
export const RESET = 'RESET';
export const SET_ENTERPRISE_ID = 'SET_ENTERPRISE_ID';
export const SET_SUBSCRIBER_ID = 'SET_SUBSCRIBER_ID';

export const SET_SSF_AVAILABLE = 'SET_SSF_AVAILABLE';
export const SET_SSF_TOKEN = 'SET_SSF_TOKEN';
export const TOGGLE_SKIP_SECOND_FACTOR = 'TOGGLE_SKIP_SECOND_FACTOR';

export const UPDATE_DEVICE_LIST = 'UPDATE_DEVICE_LIST';
export const START_DEVICE_MANAGEMENT_WORKFLOW = 'START_DEVICE_MANAGEMENT_WORKFLOW';
export const END_DEVICE_MANAGEMENT_WORKFLOW = 'END_DEVICE_MANAGEMENT_WORKFLOW';
export const START_IGNORE_TIMEOUT = 'START_IGNORE_TIMEOUT';
export const END_IGNORE_TIMEOUT = 'END_IGNORE_TIMEOUT';
export const SET_INTERPLEX_ADDRESS = 'SET_INTERPLEX_ADDRESS';
export const SET_AUTHENTICATION_TOKEN = 'SET_AUTHENTICATION_TOKEN';
export const SET_SELF_SERVICE_VERSION = 'SET_SELF_SERVICE_VERSION';
export const SHOW_INITIAL_TEMPCODE = 'SHOW_INITIAL_TEMPCODE';
export const SET_SELF_SERVICE_DEVICE_MANAGEMENT_ENABLED = 'SET_SELF_SERVICE_DEVICE_MANAGEMENT_ENABLED';
export const SET_SELF_SERVICE_SESSION_ACTIVE = 'SET_SELF_SERVICE_SESSION_ACTIVE';
export const SET_SELF_SERVICE_ENVIRONMENT = 'SET_SELF_SERVICE_ENVIRONMENT';
export const SET_IS_FROM_MORE_OPTIONS_LINK = 'SET_IS_FROM_MORE_OPTIONS_LINK';

export const START_VERIFY_EMAIL = 'START_VERIFY_EMAIL';
export const EMAIL_SUCCESS = 'EMAIL_SUCCESS';
export const INPUT_EMAIL = 'INPUT_EMAIL';

export const SET_INITIAL_USERNAME = 'SET_INITIAL_USERNAME';
export const SET_INITIAL_PASSWORD = 'SET_INITIAL_PASSWORD';

export const SET_CID_MOBILE_SERVICE_INFO = 'SET_CID_MOBILE_SERVICE_INFO';
export const SET_CID_ERROR_INFO = 'SET_CID_ERROR_INFO';

export const SET_SESSION_TRACE_ID = 'SET_SESSION_TRACE_ID';

export const RESTORE_AUTH_SESSION_FROM_IDP_SESSION_STARTED = 'RESTORE_AUTH_SESSION_FROM_IDP_SESSION_STARTED';
export const SET_RESUME_AUTH_FLOW_TOKEN = 'SET_RESUME_AUTH_FLOW_TOKEN';
export const SET_RESUME_AUTH_FLOW_TOKEN_URL = 'SET_RESUME_AUTH_FLOW_TOKEN_URL';
export const RESTORE_AUTH_SESSION_FROM_IDP_SESSION_SUCCESS = 'RESTORE_AUTH_SESSION_FROM_IDP_SESSION_SUCCESS';
export const SET_FORCE_MFA = 'SET_FORCE_MFA';
export const SET_WS_FED_RESPONSE = 'SET_WS_FED_RESPONSE';
export const REDIRECT_TO_ERROR_PAGE = 'REDIRECT_TO_ERROR_PAGE';

export const SET_OPTIONAL_WORKFLOW_NAME_AND_REQUEST_CONTEXT = 'SET_OPTIONAL_WORKFLOW_NAME_AND_REQUEST_CONTEXT';

export const SET_ERROR_HANDLER_URL = 'SET_ERROR_HANDLER_URL';

export const INIT_FACE = 'INIT_FACE';
export const START_VERIFY_ICP_FACE = 'START_VERIFY_ICP_FACE';
export const ICP_FACE_SUCCESS = 'ICP_FACE_SUCCESS';

export const SET_CIDRA_ADVANCED_UI = 'SET_CIDRA_ADVANCED_UI';

export const START_INITIATE_IDV = 'START_INITIATE_IDV';
export const START_WAIT_IDV_RESULT = 'START_WAIT_IDV_RESULT';

export const SET_STATE_TOKEN = 'SET_STATE_TOKEN';
export const RESTORE_AUTH_SESSION_STARTED = 'RESTORE_AUTH_SESSION_STARTED';
export const RESTORE_AUTH_SESSION_SUCCESS = 'RESTORE_AUTH_SESSION_SUCCESS';

export const WEB_SSO_UNKNOWN_USER_DEFERRED = 'WEB_SSO_UNKNOWN_USER_DEFERRED';
// Web SSO failure teardown that preserves the applex session, authClient, and
// tenant/user identity so the outer host wrapper does not see the applex
// connection close and remount CAUI. Only the sub-session state introduced by
// the current StartAuthSession + verifyPassword pair is cleared. Used on the
// Web SSO password-failure path instead of LOGOUT.
export const WEB_SSO_AUTH_FLOW_RESET = 'WEB_SSO_AUTH_FLOW_RESET';
export const CLEAR_LOGIN_ERROR = 'CLEAR_LOGIN_ERROR';

// Proximity Card (ProxCard) actions
export const PROX_READER_STATUS = 'PROX_READER_STATUS';
export const PROX_READER_CONNECTED = 'PROX_READER_CONNECTED';
export const PROX_READER_DISCONNECTED = 'PROX_READER_DISCONNECTED';
export const START_VERIFY_PROX_CARD = 'START_VERIFY_PROX_CARD';
